/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StaffReviewConflict
 */
export interface StaffReviewConflict {
    /**
     * 
     * @type {string}
     * @memberof StaffReviewConflict
     */
    actedByEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof StaffReviewConflict
     */
    actedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof StaffReviewConflict
     */
    currentStatus: string;
}

/**
 * Check if a given object implements the StaffReviewConflict interface.
 */
export function instanceOfStaffReviewConflict(value: object): value is StaffReviewConflict {
    if (!('actedByEmail' in value) || value['actedByEmail'] === undefined) return false;
    if (!('actedAt' in value) || value['actedAt'] === undefined) return false;
    if (!('currentStatus' in value) || value['currentStatus'] === undefined) return false;
    return true;
}

export function StaffReviewConflictFromJSON(json: any): StaffReviewConflict {
    return StaffReviewConflictFromJSONTyped(json, false);
}

export function StaffReviewConflictFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffReviewConflict {
    if (json == null) {
        return json;
    }
    return {
        
        'actedByEmail': json['actedByEmail'],
        'actedAt': (json['actedAt'] == null ? null : new Date(json['actedAt'])),
        'currentStatus': json['currentStatus'],
    };
}

export function StaffReviewConflictToJSON(json: any): StaffReviewConflict {
    return StaffReviewConflictToJSONTyped(json, false);
}

export function StaffReviewConflictToJSONTyped(value?: StaffReviewConflict | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actedByEmail': value['actedByEmail'],
        'actedAt': value['actedAt'] == null ? value['actedAt'] : value['actedAt'].toISOString(),
        'currentStatus': value['currentStatus'],
    };
}

